export const InitialFeedback = {
    fullname: '',
    email: '',
    phone: '',
    feedback: ''
};

export const InitialRating = {

    email: '',
    comments: ''

};